import React from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from 'primereact/checkbox';
import './fields.css';
const CheckboxField = ({ field, form, disabled, onChange, ...restProps }) => {
  const { t } = useTranslation();

  return (
    <div className="row gap-3 checkbox-field">
      <div className="flex align-items-center">
        <Checkbox
          inputId={field.id}
          name={field.name}
          value={field.value}
          disabled={disabled}
          onChange={(e) => {
            form.setFieldValue(field.name, e.checked);
            onChange?.(e.checked);
          }}
          checked={form.values[field.name]}
        />
        <label htmlFor={field.id} className="mx-2">
          {typeof restProps.label !== 'object'
            ? t(restProps.label)
            : restProps.label}
        </label>
      </div>
    </div>
  );
};

export default React.memo(CheckboxField);
